import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CaseDetailMainItem } from "../../../models/tr-cr-lookup/case-detail";
import { buildSummaryRequest } from "../../../state/connect-api";
import { useGetCaseBalancesMutation, useGetCaseViolationDetailsMutation } from "../../../state/globalApi";
import { updateCaseMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";

const useCaseBalance = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { activeCaseNumber, caseMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCaseBalances] = useGetCaseBalancesMutation();
  const [getCaseViolationDetails] = useGetCaseViolationDetailsMutation();
  const [violationDetails, setViolationDetails] = useState<CaseDetailMainItem>();

  useEffect(() => {
    const lookupRequest = buildSummaryRequest(activeCaseNumber);
    const fetch = async () => {
      const balances = await getCaseBalances(lookupRequest).unwrap();
      dispatch(updateCaseMaster({ balances: balances }));
    };
    fetch();
  }, [activeCaseNumber, dispatch, getCaseBalances]);

  const handleViolationView = async (caseNumber) => {
    const lookupRequest = buildSummaryRequest(caseNumber);
    const violationDetail = await getCaseViolationDetails(lookupRequest).unwrap();
    setViolationDetails(violationDetail?.MAIN[0]);
    setIsModalOpen(true);
  };

  return {
    isModalOpen,
    setIsModalOpen,
    handleViolationView,
    caseMaster,
    violationDetails
  };
};

export default useCaseBalance;
